var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" }
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            "before-close": _vm.handleClose,
            title: _vm.isEdit
              ? "Update Admin " +
                (_vm.activeAdmin && _vm.activeAdmin.admin.username) +
                " "
              : "Create Admin",
            width: "94%",
            top: "2rem"
          }
        },
        [
          _c("div", { staticClass: "row mb-2" }, [
            !_vm.isEdit
              ? _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Username", prop: "username" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.username,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "username", $$v)
                            },
                            expression: "form.username"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isEdit
              ? _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Email", prop: "email" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.email,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "email", $$v)
                            },
                            expression: "form.email"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-md-4" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "Password",
                      prop: "password",
                      rules: _vm.isEdit
                        ? _vm.rules.passwordForEdit
                        : _vm.rules.passwordForCreate
                    }
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.password,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "password", $$v)
                        },
                        expression: "form.password"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-5" },
              [
                _c("div", { staticClass: "column-heading" }, [
                  _vm._v(" Pages Access ")
                ]),
                _c("PagesAccess", {
                  attrs: {
                    checkedPagesProp: _vm.form.pages,
                    "pages-list": _vm.pagesList
                  },
                  on: {
                    change: function(p) {
                      _vm.form.pages = p
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-7" },
              [
                _c("div", { staticClass: "column-heading" }, [
                  _vm._v(" Campaigns Access ")
                ]),
                _c(
                  "el-form-item",
                  { staticClass: "auto-add-checkbox" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.form.auto_add_to_new_campaigns,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "auto_add_to_new_campaigns", $$v)
                          },
                          expression: "form.auto_add_to_new_campaigns"
                        }
                      },
                      [_vm._v(" Automatically add to all future campaigns ")]
                    )
                  ],
                  1
                ),
                _c("CampaignsAccess", {
                  attrs: { checkedCampaignsProp: _vm.form.campaigns },
                  on: {
                    change: function(c) {
                      _vm.form.campaigns = c
                    }
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.isEdit
                ? _c(
                    "el-button",
                    { on: { click: _vm.onMoveToLeadsHandlers } },
                    [_vm._v("Move to Leads Handlers")]
                  )
                : _vm._e(),
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("Cancel")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("Save")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }